import React from 'react'
import { oneOf, string, func } from 'prop-types'

import KeywordsInCategory from './KeywordsInCategory'
import Keyword from './Keyword'
import Item from './Item'

function Suggestion({
  type,
  keyword = '',
  categoryHref = '',
  categoryTitle = '',
  itemTitle = '',
  itemThumbnailImage = '',
  itemHref = '',
  searchKeyword = '',
  onKeywordClick = null,
  suggestedKeyword = '',
  thumbnailUrl = '',
}) {
  return (
    <>
      {(() => {
        switch (type) {
          case 'keywordsInCategory':
            return (
              <KeywordsInCategory
                {...{ keyword, categoryTitle, categoryHref }}
              />
            )
          case 'category':
            return (
              <Keyword
                {...{
                  suggestedKeyword,
                  searchKeyword,
                  onKeywordClick,
                  thumbnailUrl,
                }}
              />
            )
          case 'item':
            return <Item {...{ itemTitle, itemThumbnailImage, itemHref }} />
          default:
            return null
        }
      })()}
    </>
  )
}

Suggestion.propTypes = {
  type: oneOf(['keywordsInCategory', 'category', 'item']).isRequired,
  keyword: string,
  categoryHref: string,
  categoryTitle: string,
  itemTitle: string,
  itemThumbnailImage: string,
  itemHref: string,
  searchKeyword: string,
  thumbnailUrl: string,
  onKeywordClick: func,
  suggestedKeyword: string,
}

export default Suggestion
